
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coimbatore",
      function () {
        return require("private-next-pages/coimbatore/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coimbatore"])
      });
    }
  